const validateScaleName = text => {
  const size = String(text).trim().length
  return size >= 1 && size <= 64
}

export {
  validateScaleName,
}
